import Vue from 'vue';
import VueSmoothScroll from 'vue2-smooth-scroll';
import App from './App.vue';
import store from './store';
import helpers from './mixins/helpers';
import Confirm from './plugins/Confirm';
import VueI18n from 'vue-i18n';
import { languages, defaultLocale } from './locales';
import PortalVue from 'portal-vue';
import vatToggle from '@/services/vatToggle';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

Vue.config.ignoredElements = ['lord-icon'];

Vue.use(VueI18n);
Vue.use(PortalVue);
Vue.use(FloatingVue);

const messages = Object.assign(languages);

let language =
  new URLSearchParams(window.location.search).get('language') || defaultLocale;

export const i18n = new VueI18n({
  locale: language,
  fallbackLocale: defaultLocale,
  messages,
});
export const locale = i18n.locale;

Vue.prototype.$confirm = Confirm;
Vue.config.productionTip = false;
Vue.mixin(helpers);
Vue.use(VueSmoothScroll, {
  offset: -60,
});

new Vue({
  store,
  i18n,
  render: (h) => h(App),
  created() {
    this.$store.dispatch('init');

    const commitDiscountGroups = (data) => {
      this.$store.commit('discount/setDiscountGroups', data);
    };

    if (typeof window.require === 'function') {
      window.require(
        ['Magento_Customer/js/customer-data'],
        function (customerData) {
          customerData.get('discount-groups').subscribe(function (data) {
            commitDiscountGroups(data.discountGroups);
          });

          customerData.reload(['discount-groups'], true);
        }
      );
    }

    vatToggle(this.$store);
  },
}).$mount('#switch-gen');
